module.exports = __webpack_public_path__ + "static/media/skill.fcbcb4d7.png";